import React from "react";
import { CompensationHoursLoansContainer } from "../../../containers";

const CompensationHoursLoansReport = (props) => {
  return <CompensationHoursLoansContainer {...props} />;
};

export default CompensationHoursLoansReport;
